import React, { Component } from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';
import '../css/App.css';

bootstrapUtils.addStyle(Button, 'custom');

export default class GoToAppButton extends Component {
    render() {
        if (this.props.statusRequest === 200) {
            return (
                <a href="https://mutual.app.link/vcWO2UywnK"><Button bsStyle="custom" bsSize="large" type="button"><Glyphicon glyph="share" /> Abrir App</Button></a>
            );
        } else {
            return (
                <Button bsStyle="custom" bsSize="large" type="submit" disabled={this.props.password.length !== 6}>Alterar senha</Button>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/SendButton.js